// extracted by mini-css-extract-plugin
module.exports = {"servicePage":"ConciergeService_servicePage__2fS7X","decorativeImage":"ConciergeService_decorativeImage__3Sbjm"};